import { createContext, PropsWithChildren, useState } from "react"

export type SetupContextData = {
  saveCounter: number
  save: () => void
  hasChanges: boolean
  markDirty: () => void
  markClean: () => void
}

export const SetupContext = createContext<SetupContextData>({
  saveCounter: 0,
  save: () => { },
  hasChanges: false,
  markDirty: () => { },
  markClean: () => { }
})

export const SetupContextWrapper = ({ children }: PropsWithChildren) => {
  const [saveCounter, setSaveCounter] = useState(0)
  const [hasChanges, setHasChanges] = useState(false)
  return <SetupContext.Provider
    value={{
      saveCounter,
      save: () => setSaveCounter(x => x + 1),
      hasChanges,
      markDirty: () => setHasChanges(true),
      markClean: () => setHasChanges(false)
    }}
  >
    {children}
  </SetupContext.Provider>
}

